:host {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 4%;
  row-gap: 24px;
}

:host(.mobile) {
  grid-template-columns: 1fr;
}
